import { useState } from 'react';
import useDataSource from '@afosto/app-components-react/DataSource/useDataSource';

export default (
  dataSource,
  { gridOptions = {}, dataExport: dataExportSettings = {}, ...otherProps } = {},
) => {
  const dataSourceState = useDataSource(dataSource, otherProps);
  const [columnSelection, setColumnSelection] = useState(gridOptions.columnSelection || false);
  const [showColumnsSelection, setShowColumnsSelection] = useState(false);
  const [showAddColumn, setShowAddColumn] = useState(false);
  const [filterSelection, setFilterSelection] = useState(gridOptions.filterSelection || false);
  const [showFilterSelection, setShowFilterSelection] = useState(false);
  const [viewsSelection, setViewsSelection] = useState(gridOptions.viewsSelection || false);
  const [showViewsSelection, setShowViewsSelection] = useState(false);
  const [showSaveViewSelection, setShowSaveViewSelection] = useState(false);
  const [copyGridUrl, setCopyGridUrl] = useState(gridOptions.copyGridUrl || false);
  const [importData, setImportData] = useState(gridOptions.importData || false);
  const [advancedSort, setAdvancedSort] = useState(gridOptions.advancedSort || false);
  const [showAdvancedSort, setShowAdvancedSort] = useState(false);
  const [dataExport, setDataExport] = useState(gridOptions.dataExport || false);
  const [showDataExportSelection, setShowDataExportSelection] = useState(false);
  const [showFuzzySearch, setShowFuzzySearch] = useState(gridOptions.showFuzzySearch ?? true);

  return {
    ...dataSourceState,
    columnSelection,
    setColumnSelection,
    showColumnsSelection,
    setShowColumnsSelection,
    showAddColumn,
    setShowAddColumn,
    filterSelection,
    setFilterSelection,
    showFilterSelection,
    setShowFilterSelection,
    viewsSelection,
    setViewsSelection,
    showViewsSelection,
    setShowViewsSelection,
    copyGridUrl,
    setCopyGridUrl,
    importData,
    setImportData,
    advancedSort,
    setAdvancedSort,
    showAdvancedSort,
    setShowAdvancedSort,
    dataExport,
    dataExportSettings,
    setDataExport,
    showDataExportSelection,
    setShowDataExportSelection,
    showSaveViewSelection,
    setShowSaveViewSelection,
    showFuzzySearch,
    setShowFuzzySearch,
  };
};
